import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './services/auth.service';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private msalBroadcastService: MsalBroadcastService,
    private msalService: MsalService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const requiredRoles = route.data['roles'] || [];
    if (requiredRoles.length === 0) return true;

    // Wait for authentication to complete
    await this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        take(1)
      )
      .toPromise();

    try {
      const userRoles = await this.authService.getUserRoles();
      const hasAccess = requiredRoles.some((role: string) => userRoles.includes(role));
      
      if (!hasAccess) {
        this.router.navigate(['/dashboard']);
        return false;
      }
      return true;
    } catch (error) {
      console.error('Role check failed:', error);
      this.router.navigate(['/dashboard']);
      return false;
    }
  }
}